var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotelBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hotel",
    clipPath: "url(#clip0_3385_10597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 10.8337C7.21732 10.8337 8.33398 9.71699 8.33398 8.33366C8.33398 6.95033 7.21732 5.83366 5.83398 5.83366C4.45065 5.83366 3.33398 6.95033 3.33398 8.33366C3.33398 9.71699 4.45065 10.8337 5.83398 10.8337ZM15.834 5.83366H10.834C9.91732 5.83366 9.16732 6.58366 9.16732 7.50033V11.667H2.50065V5.00033C2.50065 4.54199 2.12565 4.16699 1.66732 4.16699C1.20898 4.16699 0.833984 4.54199 0.833984 5.00033V15.8337C0.833984 16.292 1.20898 16.667 1.66732 16.667C2.12565 16.667 2.50065 16.292 2.50065 15.8337V14.167H17.5006V15.8337C17.5006 16.292 17.8756 16.667 18.334 16.667C18.7923 16.667 19.1673 16.292 19.1673 15.8337V9.16699C19.1673 7.32533 17.6756 5.83366 15.834 5.83366Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 10.8337C7.21732 10.8337 8.33398 9.71699 8.33398 8.33366C8.33398 6.95033 7.21732 5.83366 5.83398 5.83366C4.45065 5.83366 3.33398 6.95033 3.33398 8.33366C3.33398 9.71699 4.45065 10.8337 5.83398 10.8337ZM15.834 5.83366H10.834C9.91732 5.83366 9.16732 6.58366 9.16732 7.50033V11.667H2.50065V5.00033C2.50065 4.54199 2.12565 4.16699 1.66732 4.16699C1.20898 4.16699 0.833984 4.54199 0.833984 5.00033V15.8337C0.833984 16.292 1.20898 16.667 1.66732 16.667C2.12565 16.667 2.50065 16.292 2.50065 15.8337V14.167H17.5006V15.8337C17.5006 16.292 17.8756 16.667 18.334 16.667C18.7923 16.667 19.1673 16.292 19.1673 15.8337V9.16699C19.1673 7.32533 17.6756 5.83366 15.834 5.83366Z",
    fill: "black",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3385_10597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelBooking);
export default __webpack_public_path__ + "static/media/hotel-booking.8ef31ed74a4bd7eac9ed9031dcbdb395.svg";
export { ForwardRef as ReactComponent };